import React, { useContext } from 'react';
import { AppContext } from 'src/components/app-context';
import { Site } from '../../reducers/types';
import * as S from './styles';
import {
  Dropdown,
  DropdownContent,
  DropdownToggle,
} from '@prisjakt/ui/dropdown';
import { Direction } from '@prisjakt/ui';
import { ButtonType } from '@prisjakt/ui/button/variants';

type SiteWithName = Site & {
  name: string;
};

type Props = {
  sites: Site[];
  current: string;
};

const ChangeMarket = ({ sites, current }: Props) => {
  const { t } = useContext(AppContext);
  const siteOptions = sites
    .filter(({ code }) => code !== current)
    .map(
      ({ url, code }) =>
        ({
          code,
          url,
          // TODO: Typescript cannot map string concatination to correct translation type.
          // Fix by adding single source of truth for markets in config and create new translation key types based on that source of truth.
          // @ts-ignore
          name: t('common', `market.${code}`),
        } as SiteWithName)
    )
    .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));

  const currentMarket = sites
    .filter(({ code }) => code === current)
    // @ts-ignore
    .map(({ code }) => t('common', `market.${code}`))
    .join();

  return (
    <Dropdown closeOnItemClick>
      <DropdownToggle
        showActiveIcon
        type={ButtonType.OUTLINED}
        containerProps={{ 'data-test': 'SiteMarketSelector' }}
      >
        <S.CountryFlag countryCode={current} altText={currentMarket} />
        <S.CountryNameWrapper>
          <S.CountryName>{currentMarket.toUpperCase()}</S.CountryName> -{' '}
          {/* @ts-ignore */}
          {t('footer', `market.${current}-url`)}
        </S.CountryNameWrapper>
      </DropdownToggle>

      <DropdownContent placement={Direction.Up}>
        <S.Sites>
          {siteOptions.map(({ name, url, code }: SiteWithName) => (
            <S.Site key={`site-${code}`}>
              <S.Link
                href={url || `/_internal/market/${code}`}
                data-test="SiteMarketSelectorOption"
                data-test-market-id={code}
              >
                <S.CountryFlag countryCode={code} />
                <S.CountryNameWrapper>
                  <S.CountryName>{name.toUpperCase()}</S.CountryName> -{' '}
                  {/* @ts-ignore */}
                  {t('footer', `market.${code}-url`)}
                </S.CountryNameWrapper>
              </S.Link>
            </S.Site>
          ))}
        </S.Sites>
      </DropdownContent>
    </Dropdown>
  );
};

export default ChangeMarket;
